// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"J2-z","subtitle":"K2-z","wrapper":"L2-z","leftArrow":"M2-z","rightArrow":"N2-z"};